import { render } from "./showPayIcon.vue?vue&type=template&id=47b562a2"
import script from "./showPayIcon.vue?vue&type=script&lang=js"
export * from "./showPayIcon.vue?vue&type=script&lang=js"

import "./showPayIcon.vue?vue&type=style&index=0&id=47b562a2&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__